export const getWishes = () => [
  {
    title: "Macbook pro stander",
    discription: "Helst Twelve South Curve i sort",
    link:
      "https://www.amazon.co.uk/dp/B07377XVNY?ots=1&ascsubtag=%5Bartid%7C2089.g.1289%5Bsrc%7C%5Bch%7C%5Blt%7Csale&linkCode=gs2&tag=hearstmagazin-21&th=1",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/71hXpGgnrgL._AC_SL1500_.jpg",
  },
  {
    title: "Uld jakke",
    discription:
      "Noget i denne stil, men jeg er ikke sikker på den er varm nok. Ellers må vi kigge på noget når i kommer til Kbh :)",
    link:
      "https://www.zalando.dk/only-and-sons-onsjulian-king-coat-frakker-klassisk-frakker-night-sky-melange-os322t09s-k11.html",
    image:
      "https://img01.ztat.net/article/spp-media-p1/d16450e0175233148ca1a27ca98d19c7/b44317aaaaea476f8e26d3b1da0676e3.jpg?imwidth=1800",
  },
  {
    title: "Razor Core X",
    discription:
      "Extren GPU til min Macbook. Det er absolut mindste priotering.",
    link: "https://www.razer.com/eu-en/gaming-laptops/razer-core-x",
    image:
      "https://assets.kogan.com/files/product/etail/Razer-/RAZ-RC21-01310100-R3B1_1.jpg?auto=webp&canvas=753%2C502&fit=bounds&height=502&quality=75&width=753",
  },
];
